/* global grecaptcha */

import { waitForGlobal } from '../utils/scriptLoader'
import BaseDriver from './BaseDriver'

/**
 * TurnstileDriver - Handles Cloudflare Turnstile
 * Uses reCAPTCHA compatibility mode for seamless integration
 */
class TurnstileDriver extends BaseDriver {
  async waitForLibrary() {
    // Turnstile loads with recaptcha compatibility
    await waitForGlobal('grecaptcha', 'render', 30000)
  }

  async getToken(action, options = {}) {
    return this.getRenderedToken(options.container)
  }

  watchForElements(container) {
    // Identical to RecaptchaV2Driver due to compatibility mode
    const elements = container.querySelectorAll('.g-recaptcha')
    elements.forEach((el) => this.renderElement(el))

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const els = node.querySelectorAll?.('.g-recaptcha')
            els?.forEach((el) => this.renderElement(el))
          }
        })
      })
    })

    observer.observe(container, {
      childList: true,
      subtree: true,
    })
  }

  renderElement(element) {
    if (element.children.length > 0) {
      return // Already rendered
    }

    grecaptcha.render(element, {
      sitekey: element.getAttribute('data-sitekey') || this.publicKey,
      theme: element.getAttribute('data-theme') || 'light',
      size: element.getAttribute('data-size') || 'normal',
    })
  }
}

export default TurnstileDriver
